exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".events-table-row .truncate{padding:2px 0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /usr/src/sentry/node_modules/css-loader?{"minimize":true}!/usr/src/sentry/node_modules/less-loader/dist/cjs.js!./less/components/eventsTableRow.less
// module id = 1045
// module chunks = 74